import React, { useEffect } from "react";

/** Пропсы компонента {@link DocumentTitle}. */
export interface DocumentTitleProps {
    /**
     * Основной текст заголовка.
     * @default "OmpMobile"
     */
    text?: string;
    /**
     * Постфикс заголовка, например окружение или сервер.
     * @default ""
     */
    postfix?: string;
    /**
     * Заголовок, который будет восстановлен при размонтировании.
     * @default "OmpMobile"
     */
    defaultTitle?: string;
}

const DEFAULT_TITLE = "OmpMobile";

/**
 * Синхронизирует `document.title` с React-деревом.
 *
 * @example
 * ```tsx
 * <DocumentTitle text="Авторизация" postfix="DEV" />
 * ```
 */
export const DocumentTitle: React.FC<DocumentTitleProps> = ({
    text = DEFAULT_TITLE,
    postfix = "",
    defaultTitle = DEFAULT_TITLE,
}) => {
    useEffect(() => {
        document.title = text + (postfix.length > 0 ? ` ${postfix}` : "");

        return () => {
            document.title = defaultTitle + (postfix.length > 0 ? ` ${postfix}` : "");
        };
    }, [defaultTitle, postfix, text]);

    return null;
};
